<template>
    <span v-if="vorzugswert" :title="$t('vorzugswert.tooltip')">
        <b-icon icon="star" style="color: #007bff;margin-left: 4px;margin-top: 4px; vertical-align: top;"></b-icon>
        <b-tooltip :target="$id('vorzugswerte')"
                   placement="right" />
    </span>
</template>

<script>
    export default {
        name: "Vorzugswert",
        props: {
            vorzugswert: Boolean
        }
    }
</script>
